import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Divider,
  Grid2,
  Typography,
} from "@mui/material";
import React from "react";
import { ReactComponent as PlusIcon } from "Assets/Icons/Settings/PlusIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import profileImg from "Assets/Images/ProfileImage.png";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  "& .discussionBox": {
    borderRadius: "8px",
    border: `1px solid ${theme.palette.border.blue}`,
    "& .header": {
      padding: "8px",
      background: theme.palette.background.default,
    },
    "& .body": {
      "&>div": {
        padding: "8px",
      },
    },
  },
});

const Discussions = () => {
  return (
    <Grid2 sx={styles}>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography variant="subtitle" fontWeight={500}>
          Posts
        </Typography>
        <Button
          variant="contained"
          startIcon={
            <PrimaryIcon
              icon={PlusIcon}
              color="white"
              height="14px"
              width="14px"
            />
          }
        >
          Add Post
        </Button>
      </Box>
      <Grid2
        container
        spacing={2}
        columns={{ lg: 12, xl: 12, md: 9, sm: 6, xs: 3 }}
      >
        {[...Array(6)]?.map((item, i) => {
          return (
            <Grid2 className="discussionBox" key={i} size={3}>
              <Box className="header">
                <Typography variant="subtitle" fontWeight={500}>
                  Three tosses of a coin
                </Typography>
              </Box>
              <Box className="body">
                <Box display={"flex"} justifyContent={"space-between"}>
                  <Typography color="secondary.light">Replies - 0</Typography>
                  <Divider flexItem orientation="vertical" />
                  <Typography color="secondary.light">View - 69</Typography>
                  <Divider flexItem orientation="vertical" />{" "}
                  <Typography color="secondary.light">
                    Activity - 4 months
                  </Typography>
                  <Divider orientation="vertical" />
                </Box>
                <Divider />
                <Box display={"flex"} justifyContent={"space-between"}>
                  <AvatarGroup spacing="medium">
                    <Avatar
                      sx={{ width: 24, border: "none !important", height: 24 }}
                      alt="Remy Sharp"
                      src={profileImg}
                    >
                      S
                    </Avatar>
                    <Avatar
                      sx={{ width: 24, border: "none !important", height: 24 }}
                      alt="Travis Howard"
                      src={profileImg}
                    >
                      T
                    </Avatar>
                    <Avatar
                      sx={{ width: 24, border: "none !important", height: 24 }}
                      alt="Cindy Baker"
                      src={profileImg}
                    >
                      B
                    </Avatar>
                  </AvatarGroup>
                  <Button variant="outlined" color="secondary" size="small">
                    View More
                  </Button>
                </Box>
              </Box>
            </Grid2>
          );
        })}
      </Grid2>
    </Grid2>
  );
};

export default Discussions;
